export const ROWS_PER_PAGE = 10;
export const MAP_LIBRARIES = "drawing";